<template>
  <v-row class="pt-5 px-3">
    <v-snackbar
      v-model="showSnackbar"
      :color="snackbarColor"
      :timeout="snackbarTimeout"
      :top="true"
    >
      <strong>{{ snackbarMsg }}</strong>
      <v-btn dark text @click="showSnackbar = false">
        <strong>CLOSE</strong>
      </v-btn>
    </v-snackbar>
    <dialog-company
      :dialog="dialogCompany"
      :company="selectedCompany"
      v-on:dialog-close="onDialogClose"
      v-if="!$root.is_admin"
    ></dialog-company>
    <dialog-file-list
      v-on:dialog-file-list-close="onDialogClose"
      :dialog="dialogFileList"
      :company="selectedCompany"
      :manage-files="true"
      title="Saved files"
    ></dialog-file-list>
    <!-- company contact list dialog -->
    <dialog-company-contact-list
      v-if="dialogContactList"
      :dialog="dialogContactList"
      :company="selectedCompany"
      :assignable="false"
      v-on:dialog-company-contact-list-close="onDialogClose"
    ></dialog-company-contact-list>

    <dialog-user-account
      :dialog="dialogUserAccount"
      :useraccount="useraccount"
      v-on:dialog-close="onDialogClose"
    ></dialog-user-account>

    <v-subheader class="headline" style="color: #1976d2"
      >User Account Management</v-subheader
    >

    <v-row no-gutters>
      <v-col cols="12" sm="12" md="8" v-if="!$root.is_admin">
        <v-card class="item elevation-3">
          <v-card-title class="title">Company Profile</v-card-title>
          <v-card-text v-if="$root.is_valid_company">
            <v-row no-gutters>
              <v-col cols="6">
                <v-list two-line>
                  <v-list-item>
                    <v-list-item-action>
                      <v-icon color="#265baf">fa-building</v-icon>
                    </v-list-item-action>

                    <v-list-item-content>
                      <v-list-item-title>
                        {{ company.name ? company.name : "" }}
                        <span style="font-size: 10px">{{
                          company.registration_number
                            ? `(${company.registration_number})`
                            : ""
                        }}</span>
                      </v-list-item-title>
                      <v-list-item-subtitle>Company</v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>

                  <v-list-item>
                    <v-list-item-action>
                      <v-icon color="#265baf">fa-dollar-sign</v-icon>
                    </v-list-item-action>

                    <v-list-item-content>
                      <v-list-item-title>{{
                        company.preferred_currency
                      }}</v-list-item-title>
                      <v-list-item-subtitle>Preferred Currency</v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>

                  <v-list-item>
                    <v-list-item-action>
                      <v-icon color="#265baf">fa-phone</v-icon>
                    </v-list-item-action>

                    <v-list-item-content>
                      <v-list-item-title v-if="company.contact_info != null">{{
                        company.contact_info.phone
                      }}</v-list-item-title>
                      <v-list-item-subtitle>Phone Number</v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>

                  <v-list-item>
                    <v-list-item-action>
                      <v-icon color="#265baf">fa-id-badge</v-icon>
                    </v-list-item-action>

                    <v-list-item-content>
                      <v-list-item-title>{{ company.company_id }}</v-list-item-title>
                      <v-list-item-subtitle>Company ID</v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
              </v-col>

              <v-col cols="6">
                <v-list two-line>
                  <v-list-item>
                    <v-list-item-action>
                      <v-icon color="#265baf">fa-map-marker-alt</v-icon>
                    </v-list-item-action>
                    <v-list-item-content v-if="company.address != null">
                      <v-list-item-title>{{
                        `${company.address.city || "city"} ${
                          company.address.state || "state"
                        }`
                      }}</v-list-item-title>
                      <v-list-item-subtitle>{{
                        company.address.country
                      }}</v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>

                  <v-list-item>
                    <v-list-item-action>
                      <v-icon color="#265baf">fa-address-book</v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                      <v-list-item-title v-if="company.contact_info != null">{{
                        `${company.contact_info.first_name || ""} ${
                          company.contact_info.last_name || ""
                        }`
                      }}</v-list-item-title>
                      <v-list-item-subtitle>Contact Person</v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>

                  <v-list-item>
                    <v-list-item-action>
                      <v-icon color="#265baf">fa-envelope</v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                      <v-list-item-title v-if="company.contact_info != null">{{
                        `${company.contact_info.email}`
                      }}</v-list-item-title>
                      <v-list-item-subtitle>Contact Email</v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-text v-else class="text-left px-4">
            This account is not assigned to a registered company. You may:
            <br />1) Register a new company by clicking on the button below or, <br />2)
            Email us at
            <a href="mailto:info@accelefreight.com">info@accelefreight.com</a> to request
            to be assigned to a registered company.
          </v-card-text>
          <v-divider></v-divider>

          <v-card-actions>
            <v-row no-gutters>
              <v-col>
                <v-btn block text color="primary" @click="onManageCompany">
                  <span class="btn-font font-weight-bold">{{
                    $root.is_valid_company ? "UPDATE COMPANY" : "REGISTER COMPANY"
                  }}</span>
                </v-btn>
              </v-col>

              <v-col>
                <v-btn
                  block
                  text
                  color="primary"
                  :disabled="!$root.is_valid_company"
                  @click="onManageSavedFiles"
                >
                  <span class="btn-font font-weight-bold">SAVED FILES</span>
                </v-btn>
              </v-col>

              <v-col>
                <v-btn
                  block
                  text
                  color="primary"
                  :disabled="!$root.is_valid_company"
                  @click="onManageSavedContacts"
                >
                  <span class="btn-font font-weight-bold">SAVED CONTACTS</span>
                </v-btn>
              </v-col>
            </v-row>
          </v-card-actions>
        </v-card>
      </v-col>

      <v-col cols="12" sm="12" md="4">
        <v-card class="item elevation-3" v-if="useraccount != null">
          <v-card-title class="headline">User Profile</v-card-title>
          <v-card-text>
            <v-list two-line class="px-3">
              <v-list-item>
                <v-list-item-action>
                  <v-icon color="#265baf">fa-user</v-icon>
                </v-list-item-action>

                <v-list-item-content>
                  <v-list-item-title>{{
                    `${useraccount.first_name} ${useraccount.last_name}`
                  }}</v-list-item-title>
                  <v-list-item-subtitle>Fullname</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>

              <v-list-item>
                <v-list-item-action>
                  <v-icon color="#265baf">fa-envelope</v-icon>
                </v-list-item-action>

                <v-list-item-content>
                  <v-list-item-title>{{ useraccount.email }}</v-list-item-title>
                  <v-list-item-subtitle>Email</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>

              <v-list-item>
                <v-list-item-action>
                  <v-icon color="#265baf">fa-phone</v-icon>
                </v-list-item-action>

                <v-list-item-content>
                  <v-list-item-title>{{ useraccount.phone_number }}</v-list-item-title>
                  <v-list-item-subtitle>Phone Number</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>

              <v-list-item>
                <v-list-item-action>
                  <v-icon color="#265baf">fa-id-badge</v-icon>
                </v-list-item-action>

                <v-list-item-content>
                  <v-list-item-title>{{ useraccount.role }}</v-list-item-title>
                  <v-list-item-subtitle>Role</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-card-text>

          <v-divider></v-divider>

          <v-card-actions>
            <v-row justify="center" no-gutters>
              <v-btn text color="red" @click="resetPassword">
                <span class="btn-font font-weight-bold">RESET PASSWORD</span>
              </v-btn>
              <v-btn text color="primary" @click="onUpdateProfile">
                <span class="btn-font font-weight-bold">UPDATE PROFILE</span>
              </v-btn>
            </v-row>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-row>
</template>

<script>
import firebase from "firebase/app";
import "firebase/auth";
import constant from "../../const";
import { setTimeout } from "timers";

export default {
  data() {
    return {
      CONSTANTS: constant,
      snackbarColor: "",
      showSnackbar: false,
      snackbarMsg: "",
      snackbarTimeout: 8000,

      dialogCompany: false,
      dialogContactList: false,
      dialogFileList: false,
      dialogUserAccount: false,

      selectedCompany: null,

      useraccount: null,
      company: {},
      saved_files: null,
      saved_contacts: null,
    };
  },
  async created() {
    // verify user token
    await this.$root.verify_user_token();

    // init
    this.init();
  },
  methods: {
    /**
     * Init the user account management page
     */
    init() {
      this.$root.blockUIshow = true;
      this.$root.blockUImsg = "Loading ...";
      // re-init user
      this.$root.re_init_user(null).then(() => {
        this.useraccount = this.$root.useraccount;

        // if company id is not null
        if (!this.$root.is_admin && this.$root.company_id != null) {
          // intialise company and user information
          this.$https
            .get("/api/company/infos/company")
            .then((res) => {
              console.log("res->", res);
              if (res.data.status == "OK") {
                this.company = res.data.data.company;
              }
              this.$root.blockUIshow = false;
            })
            .catch((err) => {
              this.$root.blockUIshow = false;
            });
        } else this.$root.blockUIshow = false;
      });
    },
    /**
     * Reset User Password
     */
    resetPassword() {
      return new Promise((success, reject) => {
        this.$root.blockUImsg = "Loading";
        this.$root.blockUIshow = true;
        try {
          var self = this;
          // initialise firebase auth
          var auth = firebase.auth();
          // get the user email address
          // and send password reset email
          auth
            .sendPasswordResetEmail(
              this.$root.useraccount.email,
              constant.ACTION_CODE_SETTING
            )
            .then(function () {
              // Email sent.
              self.showSnackbar = true;
              self.snackbarColor = "info";
              self.snackbarMsg = `Password reset link sent to ${self.$root.useraccount.email}`;

              // logout user after 1 sec
              setTimeout(() => {
                self.$root.logout();
              }, 1000);
              self.blockUIshow = false;
            })
            .catch(function (error) {
              // An error happened.
              self.blockUIshow = false;
              self.showSnackbar = true;
              self.snackbarColor = "error";
              self.snackbarMsg = error;
            });
        } catch (error) {
          // console.log("error->", error);
          this.$root.blockUIshow = false;
          this.showSnackbar = true;
          this.snackbarColor = "error";
          this.snackbarMsg = error;
        }
      });
    },

    onManageCompany() {
      this.$root.blockUImsg = "Loading";
      this.$root.blockUIshow = true;
      if (this.$root.is_valid_company) {
        var response = null;
        this.$https
          .get("/api/company/" + this.$root.company_id)
          .then((resp) => (response = resp.data))
          .catch((err) => {
            response = err.response;
          })
          .finally(() => {
            if (response.status == constant.RESPONSE_STATUS_OK) {
              this.selectedCompany = response.data;
              this.dialogCompany = true;
            } else {
              console.log(response);
            }
            this.$root.blockUIshow = false;
          });
      } else {
        this.dialogCompany = true;
        this.$root.blockUIshow = false;
      }
    },

    onManageSavedFiles() {
      this.$root.blockUImsg = "Loading";
      this.$root.blockUIshow = true;
      var response = null;
      this.$https
        .get("/api/company/" + this.$root.company_id)
        .then((resp) => (response = resp.data))
        .catch((err) => {
          response = err.response;
        })
        .finally(() => {
          if (response.status == constant.RESPONSE_STATUS_OK) {
            this.selectedCompany = response.data;
            this.dialogFileList = true;
          } else {
            console.log(response);
          }
          this.$root.blockUIshow = false;
        });
    },

    onManageSavedContacts() {
      this.$root.blockUImsg = "Loading";
      this.$root.blockUIshow = true;
      var response = null;

      this.$https
        .get("/api/company/" + this.$root.company_id)
        .then((resp) => (response = resp.data))
        .catch((err) => {
          response = err.response;
        })
        .finally(() => {
          if (response.status == constant.RESPONSE_STATUS_OK) {
            this.selectedCompany = response.data;
            this.dialogContactList = true;
          } else {
            console.log(response);
          }
          this.$root.blockUIshow = false;
        });

      // this.dialogContactList = true
    },

    onUpdateProfile() {
      this.dialogUserAccount = true;
    },

    onDialogClose(dialog, hasChange = false, company = null) {
      // console.log("dialog:->", dialog);
      this.dialogCompany = false;
      this.dialogContactList = false;
      this.dialogFileList = false;
      this.dialogUserAccount = false;
      this.selectedCompany = null;
      this.saved_files = null;
      // re init user account company information
      this.init();
    },
  },

  computed: {
    firstName: {
      get() {
        return this.$store.state.user.firstName;
      },
      set(value) {
        this.$store.commit("user/setFirstName", value);
      },
    },

    lastName: {
      get() {
        return this.$store.state.user.lastName;
      },
      set(value) {
        this.$store.commit("user/setLastName", value);
      },
    },
  },
};
</script>

<style>
.left-panel {
  border-right: 1px solid black;
  height: 400px;
}
.resultContainer {
  height: 350px;
}

.btn-font {
  font-size: 14px;
}

.item {
  min-height: 50px;
  min-width: 80px;
  margin: 10px;
}

.v-list__tile__content .v-list__tile__title {
  font-size: 14px;
}
</style>
